import {Mapper} from '@s-ui/domain'

export class SeoMakesDistributorMetaInformationMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Head} deps.seoDataValueObjectFactory
   * @param {SeoDataMapper} deps.seoDataMapper
   * @param {SeoLiteralMapper} seoLiteralMapper
   * @param {Object} deps.config
   * */
  constructor({seoDataValueObjectFactory, seoDataMapper, seoLiteralMapper, config}) {
    super()
    this._seoDataMapper = seoDataMapper
    this._seoLiteralMapper = seoLiteralMapper
    this._config = config
    this._seoDataValueObjectFactory = seoDataValueObjectFactory
  }

  /**
   * @method
   */
  async map({culture, pageName}) {
    const protocol = this._config.get('URL_PROTOCOL')
    const host = this._config.get('HOST_DOMAIN')
    const siteUrl = `${protocol}${host}`
    const MAKES_DISTRIBUTOR_SEO = this._config.get('seo').MAKES_DISTRIBUTOR_SEO

    const {H1, TITLE, META_DESCRIPTION, CANONICAL, META_ROBOTS} = MAKES_DISTRIBUTOR_SEO[pageName][culture]

    const placeholderValues = {
      siteUrl,
      year: new Date().getFullYear()
    }

    const parsedH1 = this._seoLiteralMapper.setText({text: H1}).setPlaceholderValues({placeholderValues}).map()

    const parsedCanonical = this._seoLiteralMapper
      .setText({text: CANONICAL})
      .setPlaceholderValues({placeholderValues})
      .map()

    const parsedTitle = this._seoLiteralMapper.setText({text: TITLE}).map()

    const parsedDescription = this._seoLiteralMapper.setText({text: META_DESCRIPTION}).map()

    const {
      links,
      metas,
      scripts,
      title: seoTitle
    } = this._seoDataMapper
      .title(parsedTitle)
      .description(parsedDescription)
      .canonical(parsedCanonical)
      .robots(META_ROBOTS)
      .map()

    return this._seoDataValueObjectFactory({
      h1: parsedH1,
      head: {
        link: links,
        meta: metas,
        scripts,
        title: seoTitle
      }
    })
  }
}
